/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Badge_No_SignupInputs */

const en_directory_badge_no_signup = /** @type {(inputs: Directory_Badge_No_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No signup`)
};

const zh_directory_badge_no_signup = /** @type {(inputs: Directory_Badge_No_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需注册`)
};

/**
* | output |
* | --- |
* | "No signup" |
*
* @param {Directory_Badge_No_SignupInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_badge_no_signup = /** @type {((inputs?: Directory_Badge_No_SignupInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Badge_No_SignupInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_badge_no_signup(inputs)
	return zh_directory_badge_no_signup(inputs)
});
export { directory_badge_no_signup as "directory.badge.no_signup" }